export default __webpack_public_path__ + "assets/png/e97b96723389dd237fe9c58c74261310.png";